import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import IconButton from "../../components/button/IconButton";
import { LinkIconButton } from "../../components/button/LinkIconButton";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import FunctionalTableComponent from "../../components/table/FunctionalTableComponent";
import { hasPackagingLinesFullAccess } from "../../helpers/jwt";
import { useModels } from "../../helpers/models";
import fields from "./MachineModelCreateFormConfig";
import MachineModelEditFormConfig from "./MachineModelEditFormConfig";
import columns from "./MachineModelTableConfig";

const MachineModelTablePage = (props) => {

    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);

    const models = useModels();
    const history = useHistory();

    useEffect(() => {
        if (!hasPackagingLinesFullAccess()) {
            history.push("/")
        }
    }, [])

    return (
        <>
            <Loader loader={loader} />
            <CustomContainer title={t("common.machine_models")}
                parent={
                    <div className={"d-flex"}>
                        <LinkIconButton
                            tooltip={t("menu.packing_lines")}
                            icon={models.icons.line}
                            link={"/lines"}
                            props={props}
                        />
                        <LinkIconButton
                            tooltip={t("common.machine_models")}
                            icon={models.icons["machine-model"]}
                            link={"/machine-models"}
                            props={props}
                        />
                    </div>

                }
            >


                <FunctionalTableComponent
                    title={t("forms.model_list")}
                    columns={columns(t)}
                    header={true}
                    api={"machine-model"}
                    setLoader={setLoader}
                    readOnly={!hasPackagingLinesFullAccess()}
                    removable={true}
                    deleteModalTitle={t("forms.machine_model_deletion")}
                    deleteModalDescription={t("forms.confirm_machine_model_deletion")}
                    //todo remove line
                    editable={true}
                    creationFields={fields(t)}
                    editionFields={() => MachineModelEditFormConfig(t)}
                    editWithId={true}
                    editionTitle={t("forms.machine_model_edition")}
                    additionalButtons={function (row) {
                        return <IconButton
                            variant={"outline-primary"}
                            onClick={() => {
                                history.push("/machine-model/" + row.id);
                            }}
                            size={"sm"}
                            className={"px-3"}
                            tooltip={t("common.format_parts")}
                            icon={"fa-arrow-right "}
                        />
                    }
                    }
                    width={12}
                />
            </CustomContainer>
        </>
    );
};

export default MachineModelTablePage;
